<h2>Event Balances</h2>
<div class="event-balances-table">
  <table mat-table [dataSource]="balances()" class="mat-elevation-z3">
    <ng-container matColumnDef="event">
      <th mat-header-cell *matHeaderCellDef>Event</th>
      <td mat-cell *matCellDef="let balance">
        <a mat-button color="primary" [routerLink]="['/events', balance.id]">{{
          balance.eventName
        }}</a>
      </td>
    </ng-container>
    <ng-container matColumnDef="shoutoutCount">
      <th mat-header-cell *matHeaderCellDef>Shoutouts Count</th>
      <td mat-cell *matCellDef="let balance">{{ balance.shoutoutCount }}</td>
    </ng-container>
    <ng-container matColumnDef="grossRevenue">
      <th mat-header-cell *matHeaderCellDef>Gross Revenue</th>
      <td mat-cell *matCellDef="let balance">
        {{ balance.grossRevenue | currency }}
      </td>
    </ng-container>
    <ng-container matColumnDef="netRevenue">
      <th mat-header-cell *matHeaderCellDef>Net Revenue</th>
      <td mat-cell *matCellDef="let balance">
        {{ balance.netRevenue | currency }}
      </td>
    </ng-container>
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef>Actions</th>
      <td mat-cell *matCellDef="let event">
        <button mat-button [matMenuTriggerFor]="eventMenu">...</button>
        <mat-menu #eventMenu="matMenu">
          <button mat-menu-item [routerLink]="['/events', event.id, 'edit']">
            Edit
          </button>
        </mat-menu>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>
